import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CacheService } from '../services/cashe-service';

@Directive({
  selector: '[appCheckAuth]'
})
export class CheckAuthDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  @Input() set appCheckAuth(roles: string[]) {
    // Check if the user is authenticated and has the required roles

    if (this.hasRoles(roles)) {
      // If authenticated, display the element
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // If not authenticated or doesn't have required roles, remove the element
      this.viewContainer.clear();
    }
  }


  hasRoles(allowedRoles) {
    let userRoles = CacheService.getRole();
    var rolesArr =userRoles;// userRoles.split(',');
    // if (!rolesArr || !Array.isArray(rolesArr)) {
    //   return false; // User roles not available or not in the expected format
    // }

    // Check if at least one allowed role is present in the user's roles
    return allowedRoles.some(role => rolesArr.includes(role));
  }
}
